// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"74":"917b3c4c","256":"063acfcf","496":"fae58857"}[chunkId] + ".css";
};